import { Alert, Col, Row } from "antd";

function ErrorList({ title = "Errors", errors = [], onClose = () => {}, ...props }) {
    return errors && errors.length > 0 ? (
        <Row style={{ ...(props.style || {}), marginBottom: "1rem" }}>
            <Col span={24}>
                <Alert
                    title={title}
                    description={
                        <>
                            {errors.map((error, index) => (
                                <p key={index}>{error}</p>
                            ))}
                        </>
                    }
                    type="error"
                    closable={{
                        onClose,
                    }}
                />
            </Col>
        </Row>
    ) : (
        <></>
    );
}

export default ErrorList;
